module.exports = __webpack_public_path__ + "img/toyota.dfe544b5.jpeg";